import React from 'react';
import LegalLayout from './LegalLayout';

// TODO: Sobald eRecht24-API-Key vorhanden ist, ersetzt der Backend-Endpoint
// /api/legal/datenschutz diesen statischen Inhalt. Bis dahin manuell pflegen.
const Datenschutz = () => (
  <LegalLayout title="Datenschutzerklärung">
    <h2>1. Verantwortlicher</h2>
    <p>
      Dwayne Advertising · Alexander Fischl · Beispielstraße 1 · 80331 München ·
      hallo@dwayne-advertising.de
    </p>

    <h2>2. Hosting</h2>
    <p>
      offfer.de wird auf einem Server der Hetzner Online GmbH (Industriestr. 25,
      91710 Gunzenhausen) in Deutschland gehostet. Mit Hetzner besteht ein
      Auftragsverarbeitungs-Vertrag nach Art. 28 DSGVO. Beim Aufruf der Seite
      werden technisch notwendige Verbindungsdaten verarbeitet (IP-Adresse,
      Zeitpunkt, aufgerufene URL, User-Agent) — gespeichert nur in flüchtigen
      Server-Logs zur Abwehr von Angriffen und schnellstmöglich gelöscht.
    </p>

    <h2>3. Datenverarbeitung im Account-Bereich</h2>
    <p>
      Bei der Registrierung speichern wir: E-Mail, Name, Firmenname, Passwort
      (gehasht mit bcrypt). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO
      (Vertragserfüllung). Die Daten werden gelöscht, sobald Sie Ihren Account
      löschen.
    </p>

    <h2>4. Angebotsdaten</h2>
    <p>
      Im Rahmen der Nutzung von offfer erstellen Sie Angebote für Ihre Kunden.
      Diese Daten (Kundenadresse, Positionen, Preise, Notizen) liegen in einer
      Multi-Tenant-Datenbank — Sie sehen nur Ihre eigenen Daten. Wir verarbeiten
      diese Daten als Auftragsverarbeiter für Sie nach Art. 28 DSGVO.
    </p>

    <h2>5. Öffentliche Angebotslinks und Nutzungsmessung</h2>
    <p>
      Die von Ihnen erstellten Angebote sind über einen nicht-erratbaren Hash
      öffentlich abrufbar. Beim Aufruf einer Angebotsseite erfassen wir zur
      Auswertung für den jeweiligen Angebotsersteller folgende Nutzungsdaten:
      Zeitpunkt des Aufrufs, Verweildauer, Geräteklasse (Desktop/Mobil) sowie
      Interaktionen auf der Seite (z.&nbsp;B. geöffnete Abschnitte, An- und
      Abwahl optionaler Positionen, PDF-Export, Annahme des Angebots).
    </p>
    <p>
      Die Messung erfolgt bewusst datensparsam: Es werden <strong>keine
      Cookies</strong> gesetzt, kein Local Storage verwendet und
      <strong> keine IP-Adressen oder Browser-Kennungen (User-Agent)
      gespeichert</strong>. Zur Zuordnung eines Besuchs wird ausschließlich
      eine zufällig erzeugte Sitzungs-Kennung verwendet, die nur im
      Arbeitsspeicher des Browsers existiert und mit dem Schließen bzw.
      Neuladen der Seite verfällt. Eine Identifizierung der besuchenden Person
      oder eine seitenübergreifende Nachverfolgung ist damit nicht möglich;
      ein Abgleich mit anderen Daten findet nicht statt.
    </p>
    <p>
      Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO
      (berechtigtes Interesse des Angebotserstellers an der Nachverfolgung
      seines Angebots im Rahmen der Vertragsanbahnung) bzw. Art.&nbsp;6
      Abs.&nbsp;1 lit.&nbsp;b DSGVO, soweit der Aufruf der Anbahnung oder
      Durchführung eines Vertrags mit Ihnen dient. Die Nutzungsdaten werden
      zusammen mit dem zugehörigen Angebot gespeichert und mit dessen Löschung
      entfernt. Sie können der Verarbeitung jederzeit mit Wirkung für die
      Zukunft widersprechen (Kontakt siehe Abschnitt&nbsp;1).
    </p>

    <h2>6. Cookies</h2>
    <p>
      offfer setzt nur <strong>technisch notwendige</strong> Cookies/LocalStorage-Einträge:
      JWT-Token für die Anmeldung. Es werden <strong>keine Marketing- oder
      Analyse-Cookies</strong> gesetzt — daher kein Consent-Banner.
    </p>

    <h2>7. Schriftarten</h2>
    <p>
      Schriftarten werden ausschließlich vom eigenen Server geliefert — kein
      Google Fonts CDN, keine externen Verbindungen.
    </p>

    <h2>8. KI-Funktionen (optional)</h2>
    <p>
      Bei Nutzung der optionalen KI-Funktionen (Angebots-Intro, Chatbot,
      Sales-Coaching) werden die von Ihnen eingegebenen Texte an OpenAI
      (OpenAI Ireland Ltd., 1st Floor, The Liffey Trust Centre, 117–126 Sheriff
      Street Upper, Dublin 1, D01 YC43, Irland) übermittelt. Rechtsgrundlage:
      Art. 6 Abs. 1 lit. b DSGVO. OpenAI verarbeitet die Daten nach
      Standardvertragsklauseln. Sie können diese Funktionen jederzeit nicht
      nutzen.
    </p>

    <h2>9. E-Mail-Versand</h2>
    <p>
      Beim Versand von Angeboten/Reset-Mails nutzen wir Mailgun (Mailgun
      Technologies Ireland Ltd.) im EU-Modus. Es werden Empfänger-Adresse und
      Mail-Inhalt verarbeitet. AVV mit Mailgun liegt vor.
    </p>

    <h2>10. Ihre Rechte</h2>
    <p>
      Sie haben jederzeit das Recht auf Auskunft (Art. 15), Berichtigung
      (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit
      (Art. 20) und Widerspruch (Art. 21) gegenüber der Verarbeitung. Anfragen
      richten Sie bitte an die im Impressum genannte E-Mail-Adresse.
    </p>
    <p>
      Beschwerderecht bei der zuständigen Aufsichtsbehörde
      (Bayerisches Landesamt für Datenschutzaufsicht, Promenade 18, 91522 Ansbach).
    </p>

    <h2>11. Änderungen dieser Erklärung</h2>
    <p>
      Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
      stets den aktuellen rechtlichen Anforderungen entspricht. Die jeweils
      aktuelle Version finden Sie auf dieser Seite.
    </p>
  </LegalLayout>
);

export default Datenschutz;
